import { fetchApiHub } from '../../lib/fetch-api-hub';
import { Brand } from '@Types/brands/Brand';

export const getBrandDetails = async (brandName?: string): Promise<Brand> => {
  return await fetchApiHub('/action/brands/getBrandDetails', { method: 'POST' }, { brandName }).catch(
    (error) => undefined,
  );
};
